module.exports = __webpack_public_path__ + "static/media/spinner_spoors_anim2.959e635e.gif";